import { render, staticRenderFns } from "./EmployeeDetailView.vue?vue&type=template&id=55e84eea&scoped=true&"
import script from "./EmployeeDetailView.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e84eea",
  null
  
)

export default component.exports